import Vue from "vue";
import Router from "vue-router";
let Index = resolve => {
  require(["@/views/index"], resolve);
};
let Home = resolve => {
  require(["@/views/home/index"], resolve);
};
let UploadProduct = resolve => {
  require(["@/views/controlProduct/upload_product"], resolve);
};
let ComtrolProduct = resolve => {
  require(["@/views/controlProduct/control_product"], resolve);
};
let ComtrolMate = resolve => {
  require(["@/views/controlProduct/control_mate"], resolve);
};
let ComtrolOrder = resolve => {
  require(["@/views/controlOrder/control_order"], resolve);
};
let ComtrolWallet = resolve => {
  require(["@/views/controlOrder/control_wallet"], resolve);
};
let ComtrolShop = resolve => {
  require(["@/views/controlShop/control_shop_info"], resolve);
};
let ComtrolMember = resolve => {
  require(["@/views/controlShop/control_member"], resolve);
};
let ComtrolService = resolve => {
  require(["@/views/controlShop/control_service"], resolve);
};
let siteCLock = resolve => {
  require(["@/views/controlShop/siteCLock"], resolve);
};
let updataProduct = resolve => {
  require(["@/views/controlProduct/updata_product"], resolve);
};
let myBank = resolve => {
  require(["@/views/controlOrder/myBank"], resolve);
};
let withdrawalRecord = resolve => {
  require(["@/views/controlOrder/withdrawalRecord"], resolve);
};
let controlProject = resolve => {
  require(["@/views/controlOrder/control_project"], resolve);
};
let AicontrolProject = resolve => {
  require(["@/views/controlOrder/Aicontrol_project"], resolve);
};
let projectTemplate = resolve => {
  require(["@/views/controlOrder/projectTemplate/index"], resolve);
};
let controlBidding = resolve => {
  require(["@/views/controlDemand/control_bidding"], resolve);
};
let controlBid = resolve => {
  require(["@/views/controlDemand/control_bid"], resolve);
};
let priceManage = resolve => {
  require(["@/views/activityManagement/priceManage/index"], resolve);
};
let bidDetails = resolve => {
  require(["@/views/activityManagement/bidDetails/index"], resolve);
};
let seckill = resolve => {
  require(["@/views/activityManagement/seckill/index"], resolve);
};
let groupPurchase = resolve => {
  require(["@/views/activityManagement/groupPurchase"], resolve);
};
let agenManagement = resolve => {
  require(["@/views/activityManagement/agenManagement/index"], resolve);
}
let constructionStandard = resolve => {
  require(["@/views/controlOrder/constructionStandard/index"], resolve);
};
let pay = resolve => {
  require(["@/views/pay"], resolve);
};
let qrcode = resolve => {
  require(["@/views/qrcode"], resolve);
};
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题--来自H
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
Vue.use(Router);
const router = new Router({
  routes: [
    {
      //贝贝猫首页
      path: "/",
      name: "Index",
      meta: {},
      component: Index,
      children: [
        {
          path: "/",
          name: "Index",
          component: Home
        },
        {
          path: "/upload_product",
          name: "UploadProduct",
          component: UploadProduct
        },
        {
          path: "/control_product",
          name: "ComtrolProduct",
          component: ComtrolProduct
        },
        {
          path: "/control_mate",
          name: "ComtrolMate",
          component: ComtrolMate
        },
        {
          path: "/control_order",
          name: "ComtrolOrder",
          component: ComtrolOrder
        },
        {
          path: "/control_wallet",
          name: "ComtrolWallet",
          component: ComtrolWallet
        },

        {
          path: "/control_shop",
          name: "ComtrolShop",
          component: ComtrolShop
        },
        {
          path: "/control_member",
          name: "ComtrolMember",
          component: ComtrolMember
        },
        {
          path: "/control_service",
          name: "ComtrolService",
          component: ComtrolService
        },
        {
          path: "/siteCLock",
          name: "siteCLock",
          component: siteCLock
        },
        {
          path: "/updata_product",
          name: "updata_product",
          component: updataProduct
        },
        {
          path: "/myBank",
          name: "myBank",
          component: myBank
        },
        {
          path: "/withdrawalRecord",
          name: "withdrawalRecord",
          component: withdrawalRecord
        },
        {
          path: "/control_project",
          name: "control_project",
          component: controlProject
        },
        {
          path: "/Aicontrol_project",
          name: "Aicontrol_project",
          component: AicontrolProject
        },
        {
          path: "/projectTemplate",
          name: "projectTemplate",
          component: projectTemplate
        },
        {
          path: "/constructionStandard",
          name: "constructionStandard",
          component: constructionStandard
        },
        {
          path: "/control_badding",
          name: "control_badding",
          component: controlBidding
        },
        {
          path: "/control_bad",
          name: "control_badg",
          component: controlBid
        },
        {
          path: "/pay",
          name: "pay",
          component: pay
        },
        {
          path: "/priceManage",
          name: "priceManage",
          component: priceManage
        },
        {
          path: "/bidDetails",
          name: "bidDetails",
          component: bidDetails
        },
        {
          path: "/seckill",
          name: "seckill",
          component: seckill
        },
        {
          path: "/groupPurchase",
          name: "groupPurchase",
          component: groupPurchase
        },
        {
          path: "/agenManagement",
          name: "agenManagement",
          component: agenManagement
        }
      ]
    },
    {
      path: "/qrcode",
      name: "qrcode",
      component: qrcode
    },
    {
      //登录页面
      path: "/demandLogin",
      name: "demandLogin",
      component: resolve => {
        require(["@/views/login"], resolve);
      }
    },
    {
      //登录页面
      path: "/login",
      name: "login",
      component: resolve => {
        require(["@/views/new_login"], resolve);
      }
    },
    {
      //注册页面
      path: "/register",
      name: "register",
      component: resolve => {
        require(["@/views/register"], resolve);
      }
    },
    {
      //忘记密码
      path: "/forgetPassword",
      name: "忘记密码",
      component: resolve => {
        require(["@/views/forgetPassword"], resolve);
      }
    },
    {
      //注册成功
      path: "/registeredSuccessfully",
      name: "注册成功",
      component: resolve => {
        require(["@/views/registeredSuccessfully"], resolve);
      }
    },
    { //页面重定向
      path: '*',
      redirect: '/login',
      name: '',
    }
  ]
});
// 全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.meta.isLogin) {
    //判断是否需要登录
    next();
  } else {
    next();
  }
});
// 全局后置守卫
router.afterEach(() => { });
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js